// frontend/src/pages/admin/AdminActivityPage.js
import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { 
    FaGlobe, FaDesktop, FaClock, FaUserSecret, FaSyncAlt, 
    FaSignInAlt, FaCopy, FaEye, FaNetworkWired, FaMobileAlt,
    FaSearch, FaFilter, FaChevronLeft, FaChevronRight 
} from 'react-icons/fa';

const AdminActivityPage = () => {
    // --- STATE YÖNETİMİ ---
    const [stats, setStats] = useState(null);
    const [activities, setActivities] = useState([]);
    const [loading, setLoading] = useState(true);
    
    // Filtreleme ve Sayfalama
    const [search, setSearch] = useState('');
    const [typeFilter, setTypeFilter] = useState('all');
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(25); // Varsayılan 25 (5. İSTEK)
    const [totalPages, setTotalPages] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);

    const API_URL = process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5000/api';
    const getCleanToken = () => localStorage.getItem('token')?.replace(/"/g, '');

    // --- VERİ ÇEKME ---
    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            const token = getCleanToken();
            const config = { headers: { Authorization: `Bearer ${token}` } };
            
            // Query Parametreleri
            const query = `?page=${page}&limit=${limit}&search=${search}&type=${typeFilter}`;
            
            const { data } = await axios.get(`${API_URL}/extras/admin-stats${query}`, config);
            
            setStats({
                onlineUsers: data.onlineUsers,
                summary: data.summary
            });
            setActivities(data.pagination.activities);
            setTotalPages(data.pagination.pages);
            setTotalRecords(data.pagination.total);
            
            setLoading(false);
        } catch (error) {
            console.error("Stats Error:", error);
            setLoading(false);
        }
    }, [page, limit, typeFilter, search, API_URL]); // search bağımlılığını ekledik ama butona bağlayacağız

    // 6. İSTEK: Otomatik yenileme kaldırıldı. Sadece ilk açılışta ve filtre değişiminde çalışır.
    useEffect(() => {
        fetchData();
    }, [fetchData]);

    // --- YARDIMCI FONKSİYONLAR (4. İSTEK) ---
    
    // 1. User Agent Temizleyici (Cihazı sadeleştirme)
    const formatUserAgent = (ua) => {
        if (!ua) return 'Bilinmiyor';
        let os = 'OS?';
        let browser = 'Browser?';

        // İşletim Sistemi
        if (ua.includes('Windows NT 10.0')) os = 'Windows 10/11';
        else if (ua.includes('Windows NT 6.3')) os = 'Windows 8.1';
        else if (ua.includes('Mac OS X')) os = 'macOS';
        else if (ua.includes('Android')) os = 'Android';
        else if (ua.includes('iPhone')) os = 'iPhone';
        else if (ua.includes('Linux')) os = 'Linux';

        // Tarayıcı
        if (ua.includes('Chrome') && !ua.includes('Edg')) browser = 'Chrome';
        else if (ua.includes('Firefox')) browser = 'Firefox';
        else if (ua.includes('Safari') && !ua.includes('Chrome')) browser = 'Safari';
        else if (ua.includes('Edg')) browser = 'Edge';

        return `${os} - ${browser}`;
    };

    // 2. Detay Türkçeleştirme
    const formatDetails = (details, type) => {
        if (!details) return type;
        
        let text = details;
        // URL'leri Türkçeleştir
        if (text.includes('/user/dashboard')) text = text.replace(/\/user\/dashboard/g, 'Kullanıcı Paneli');
        if (text.includes('/user/profile')) text = text.replace(/\/user\/profile/g, 'Profil Sayfası');
        if (text.includes('/user/announcements')) text = text.replace(/\/user\/announcements/g, 'Duyurular Sayfası');
        if (text.includes('/user/recommendations')) text = text.replace(/\/user\/recommendations/g, 'Öneriler Sayfası');
        if (text.includes('/user/mailpool')) text = text.replace(/\/user\/mailpool/g, 'Mail Havuzu');
        if (text.includes('/login')) text = text.replace(/\/login/g, 'Giriş Ekranı');

        return text;
    };

    const getDeviceIcon = (ua) => {
        if (!ua) return <FaDesktop />;
        if (ua.toLowerCase().includes('mobile') || ua.toLowerCase().includes('android') || ua.toLowerCase().includes('iphone')) return <FaMobileAlt />;
        return <FaDesktop />;
    };

    const getActivityStyle = (type) => {
        switch (type) {
            case 'session_start': return { color: 'text-green-400', icon: <FaSignInAlt />, label: 'Oturum Açtı' };
            case 'copy_password': return { color: 'text-red-400', icon: <FaCopy />, label: 'Şifre Kopyalama' };
            case 'copy_email': return { color: 'text-yellow-400', icon: <FaCopy />, label: 'Email Kopyalama' };
            case 'page_view': return { color: 'text-blue-400', icon: <FaEye />, label: 'Sayfa Gezintisi' };
            default: return { color: 'text-gray-400', icon: <FaNetworkWired />, label: type };
        }
    };

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        setPage(1); // Aramada ilk sayfaya dön
        fetchData();
    };

    return (
        <div className="space-y-6 pb-10">
            {/* BAŞLIK */}
            <div className="flex justify-between items-center">
                <div>
                    <h1 className="text-2xl font-bold text-white flex items-center gap-2">
                        <FaUserSecret className="text-primary"/> Aktivite Merkezi
                    </h1>
                    <p className="text-text-secondary text-sm">Sistemdeki anlık hareketler ve loglar.</p>
                </div>
                <button onClick={fetchData} className="bg-gray-800 hover:bg-gray-700 text-white p-2 rounded-full transition-all border border-gray-600">
                    <FaSyncAlt className={loading ? 'animate-spin' : ''} />
                </button>
            </div>

            {/* 1. ÖZET KARTLAR (İSTEK 1: Düzeltildi) */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="bg-surface border border-border p-6 rounded-xl shadow-lg relative overflow-hidden">
                    <h3 className="text-gray-400 text-xs font-bold uppercase">Bugün Giriş</h3>
                    <p className="text-3xl font-bold text-white mt-2">{stats?.summary?.loginsToday || 0}</p>
                    <div className="absolute -bottom-4 -right-4 text-green-500/10 text-6xl"><FaSignInAlt /></div>
                </div>
                <div className="bg-surface border border-border p-6 rounded-xl shadow-lg relative overflow-hidden">
                    <h3 className="text-gray-400 text-xs font-bold uppercase">Bugün Sayfa Gösterimi</h3>
                    <p className="text-3xl font-bold text-white mt-2">{stats?.summary?.visitsToday || 0}</p>
                    <div className="absolute -bottom-4 -right-4 text-blue-500/10 text-6xl"><FaEye /></div>
                </div>
                <div className="bg-surface border border-border p-6 rounded-xl shadow-lg relative overflow-hidden">
                    <h3 className="text-gray-400 text-xs font-bold uppercase">Bugün Kopyalama</h3>
                    <p className="text-3xl font-bold text-white mt-2">{stats?.summary?.copiesToday || 0}</p>
                    <div className="absolute -bottom-4 -right-4 text-red-500/10 text-6xl"><FaCopy /></div>
                </div>
            </div>

            {/* 2. ONLINE KULLANICILAR (İSTEK 2: 15 Dk Oldu) */}
            <div className="bg-surface border border-border rounded-xl p-6 shadow-lg">
                <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2">
                    <span className="w-3 h-3 bg-green-500 rounded-full animate-pulse"></span>
                    Online Kullanıcılar (Son 15 dk)
                </h3>
                {stats?.onlineUsers?.length > 0 ? (
                    <div className="flex flex-wrap gap-4">
                        {stats.onlineUsers.map(u => (
                            <div key={u._id} className="flex items-center gap-3 bg-gray-800 p-3 rounded-lg border border-gray-700 animate-fadeIn">
                                <img src={u.avatar || '/avatar/default-avatar.png'} alt={u.name} className="w-10 h-10 rounded-full object-cover border-2 border-green-500"/>
                                <div>
                                    <p className="text-white font-bold text-sm">{u.name}</p>
                                    <p className="text-xs text-text-secondary">{u.role.toUpperCase()}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <p className="text-gray-500 text-sm italic">Şu an aktif kullanıcı yok.</p>
                )}
            </div>

            {/* 3. FİLTRELEME VE ARAMA (İSTEK 3) */}
            <div className="bg-gray-800/50 p-4 rounded-xl border border-gray-700 flex flex-col md:flex-row gap-4 items-center justify-between">
                <form onSubmit={handleSearchSubmit} className="relative w-full md:w-1/3">
                    <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" />
                    <input 
                        type="text" 
                        placeholder="Kullanıcı adı ara..." 
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        className="w-full bg-gray-900 border border-gray-600 rounded-lg pl-10 pr-4 py-2 text-white outline-none focus:border-primary text-sm"
                    />
                </form>

                <div className="flex gap-4 w-full md:w-auto overflow-x-auto">
                    <select 
                        value={typeFilter} 
                        onChange={(e) => { setTypeFilter(e.target.value); setPage(1); }}
                        className="bg-gray-900 border border-gray-600 text-white text-sm rounded-lg p-2 outline-none focus:border-primary"
                    >
                        <option value="all">Tüm Aktiviteler</option>
                        <option value="session_start">Oturum Açma</option>
                        <option value="page_view">Sayfa Gezintisi</option>
                        <option value="copy_password">Şifre Kopyalama</option>
                        <option value="copy_email">E-Posta Kopyalama</option>
                    </select>

                    <select 
                        value={limit} 
                        onChange={(e) => { setLimit(Number(e.target.value)); setPage(1); }}
                        className="bg-gray-900 border border-gray-600 text-white text-sm rounded-lg p-2 outline-none focus:border-primary"
                    >
                        <option value="25">25 Kayıt</option>
                        <option value="50">50 Kayıt</option>
                        <option value="100">100 Kayıt</option>
                    </select>
                </div>
            </div>

            {/* 4. DETAYLI AKTİVİTE LOGLARI (LİSTE) */}
            <div className="bg-surface border border-border rounded-xl shadow-lg overflow-hidden">
                <div className="p-4 border-b border-gray-700 flex justify-between items-center">
                    <h3 className="text-lg font-bold text-white">İşlem Kütüğü</h3>
                    <span className="text-xs text-gray-500">Toplam {totalRecords} kayıt bulundu.</span>
                </div>
                <div className="overflow-x-auto">
                    <table className="w-full text-left text-sm text-gray-400">
                        <thead className="bg-gray-800 text-gray-300 uppercase font-bold text-xs">
                            <tr>
                                <th className="p-4">Kullanıcı</th>
                                <th className="p-4">İşlem Tipi</th>
                                <th className="p-4">Açıklama / Detay</th>
                                <th className="p-4">Cihaz & IP</th>
                                <th className="p-4">Zaman</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-800">
                            {activities.map(act => {
                                const style = getActivityStyle(act.type);
                                return (
                                    <tr key={act._id} className="hover:bg-gray-800/50 transition-colors">
                                        {/* KULLANICI */}
                                        <td className="p-4 flex items-center gap-3">
                                            {act.userId ? (
                                                <>
                                                    <img src={act.userId.avatar || '/avatar/default-avatar.png'} alt="avt" className="w-8 h-8 rounded-full border border-gray-600" />
                                                    <div>
                                                        <span className="font-bold text-white block">{act.userId.name}</span>
                                                        <span className="text-[10px] text-gray-500">{act.userId.role}</span>
                                                    </div>
                                                </>
                                            ) : <span className="text-red-400 font-bold flex items-center gap-1"><FaUserSecret/> Silinmiş Üye</span>}
                                        </td>
                                        
                                        {/* İŞLEM TİPİ */}
                                        <td className="p-4">
                                            <span className={`flex items-center gap-2 font-bold text-xs border px-2 py-1 rounded-md w-fit bg-opacity-10 ${style.color.replace('text-', 'bg-')} border-opacity-20 border-gray-500`}>
                                                {style.icon} {style.label}
                                            </span>
                                        </td>
                                        
                                        {/* DETAY (İSTEK 4: Türkçeleştirilmiş) */}
                                        <td className="p-4 text-white text-sm">
                                            {formatDetails(act.details, act.type)}
                                        </td>
                                        
                                        {/* CİHAZ & IP (İSTEK 4: Ayrıştırılmış ve Okunaklı) */}
                                        <td className="p-4">
                                            <div className="flex flex-col gap-1">
                                                <div className="flex items-center gap-1.5 text-xs text-blue-300 bg-blue-900/20 px-2 py-0.5 rounded w-fit">
                                                    <FaGlobe size={10}/> 
                                                    <span className="font-mono">{act.ip}</span>
                                                </div>
                                                <div className="flex items-center gap-1.5 text-xs text-gray-400" title={act.userAgent}>
                                                    {getDeviceIcon(act.userAgent)} 
                                                    <span>{formatUserAgent(act.userAgent)}</span>
                                                </div>
                                            </div>
                                        </td>
                                        
                                        {/* ZAMAN */}
                                        <td className="p-4 flex flex-col text-xs font-mono text-gray-400">
                                            <span className="text-white font-bold">{new Date(act.createdAt).toLocaleTimeString('tr-TR')}</span>
                                            <span>{new Date(act.createdAt).toLocaleDateString('tr-TR')}</span>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                    {activities.length === 0 && (
                        <div className="p-10 text-center flex flex-col items-center text-gray-500">
                            <FaFilter size={30} className="mb-2 opacity-50"/>
                            <p>Kriterlere uygun kayıt bulunamadı.</p>
                        </div>
                    )}
                </div>

                {/* 5. SAYFALAMA (PAGINATION) - İSTEK 5 */}
                {totalPages > 1 && (
                    <div className="p-4 border-t border-gray-700 flex justify-between items-center bg-gray-800/50">
                        <button 
                            onClick={() => setPage(p => Math.max(1, p - 1))} 
                            disabled={page === 1}
                            className="px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2 text-sm font-bold transition-colors"
                        >
                            <FaChevronLeft /> Önceki
                        </button>
                        
                        <span className="text-sm text-gray-400 font-mono">
                            Sayfa <span className="text-white font-bold">{page}</span> / {totalPages}
                        </span>

                        <button 
                            onClick={() => setPage(p => Math.min(totalPages, p + 1))} 
                            disabled={page === totalPages}
                            className="px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2 text-sm font-bold transition-colors"
                        >
                            Sonraki <FaChevronRight />
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AdminActivityPage;